import type { Session } from "@bimone/bimtrack-core";
import type { Configurations } from "@env/EnvironmentVariables";

export const getBimTrackUrl = (session: Session): string => {
  const regionalUrl = getBimTrackRegionalUrl(session);
  const baseUrl = getBimTrackBaseUrl(session);

  return regionalUrl || baseUrl;
};

export const getBimTrackBaseUrl = (session: Session): string => {
  const { bimTrackApiUrl } = session;
  return bimTrackApiUrl;
};

export const getBimTrackRegionalUrl = (session: Session): string | undefined => {
  const { hub } = session;
  return hub?.bimTrackRegionalApiUrl;
};

export const getSubscriptionApiUrl = (configurations: Configurations): string => {
  return configurations.subscriptionServiceApi?.replace("/v1", "") || "";
};

export const getFileManagementUrl = (session: Session, configurations: Configurations, dataCenter?: string): string => {

  const baseUrl = getFileManagementBaseUrl(configurations);
  const regionalUrl = getFileManagementRegionalUrl(session, configurations, dataCenter);

  return regionalUrl || baseUrl;
};

export const getFileManagementBaseUrl = (configurations: Configurations, dataCenter?: string | null): string => {
  const {
    fileManagementRegionalUrlTemplate,
    fileManagementApiBaseUrl
  } = configurations;

  if(!dataCenter || !fileManagementRegionalUrlTemplate){
    return fileManagementApiBaseUrl;
  }

  return fileManagementRegionalUrlTemplate?.replace("{datacenter}", "bt" + dataCenter.toString().padStart(2, '0'));
};

export const getFileManagementRegionalUrl = (session: Session, configurations: Configurations, dataCenter?: string): string | undefined => {
  const { hub } = session;

  const hubDataCenter = dataCenter ?? hub?.dataCenterInfo.id;

  if (typeof(hubDataCenter) !== 'number' || hubDataCenter < 0) {
    return;
  }

  const { fileManagementRegionalUrlTemplate } = configurations;
  return fileManagementRegionalUrlTemplate?.replace("{datacenter}", "bt" + hubDataCenter.toString().padStart(2, '0'));
};

export function stripTrailingSlash(url: string): string {
  return url.replace(/\/+$/, '');
}
